import { render, staticRenderFns } from "./MealBookComponent.vue?vue&type=template&id=6fd99c91&scoped=true&"
import script from "./MealBookComponent.vue?vue&type=script&lang=ts&"
export * from "./MealBookComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MealBookComponent.vue?vue&type=style&index=0&id=6fd99c91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd99c91",
  null
  
)

export default component.exports